import { gql } from "@apollo/client";
import {TypeDefinitionAttributeFields} from "../fragments/typeDefinitionAttribute";

export const GridViewTDAs = gql`
    query GridViewTDAs ($id: ID!) {
        gridView (id: $id) {
            id
            title
            typeDefinitionAttributeList {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
